module.exports = __webpack_public_path__ + "static/media/yashind-problem1.f0669d8c.png";